import { emailTemplateToHref, HELP_EMAIL_ADDRESS } from '#src/pages/group/support/support_email.ts';
import { DisplayParticipantName } from '#src/ui/presentation/display_participant_name.tsx';
import { Anchor } from '@packages/ui/base/anchor/anchor';
import { Button } from '@packages/ui/base/button/button';
import { Card } from '@packages/ui/base/card/card';
import { EnvelopeIcon, PlusIcon, QuestionIcon } from '@phosphor-icons/react';

export interface HelpCardProps {
  participantId: string;
  participantName: string;
  /** Absolute link to this group, included in support emails. */
  groupUrl: string;
  createGroupHref: string;
  onLeaveClick: () => void;
}

export const HelpCard = ({
  participantId,
  participantName,
  groupUrl,
  createGroupHref,
  onLeaveClick,
}: HelpCardProps) => {
  return (
    <Card className="py-6">
      <h2 className="mb-4 text-xl font-bold">Need help?</h2>
      <div className="text-muted-foreground flex flex-col items-start gap-3">
        <Button variant="link" size="none" className="max-w-full" onClick={onLeaveClick}>
          <QuestionIcon className="mr-2 size-4 shrink-0" />
          <span className="min-w-0 truncate">
            I am not <DisplayParticipantName name={participantName} />
          </span>
        </Button>
        <Anchor href={createGroupHref} className="text-muted-foreground flex items-center">
          <PlusIcon className="mr-2 size-4" />
          Create a new secret santa
        </Anchor>
        <Anchor
          href={getContactUsHref({ participantId, groupUrl })}
          target="_blank"
          rel="noopener noreferrer"
          className="text-muted-foreground flex items-center"
        >
          <EnvelopeIcon className="mr-2 size-4" /> Contact us
        </Anchor>
      </div>
    </Card>
  );
};

const getContactUsHref = ({
  participantId,
  groupUrl,
}: {
  participantId: string;
  groupUrl: string;
}) =>
  emailTemplateToHref({
    to: HELP_EMAIL_ADDRESS,
    subject: 'Help with my secret santa',
    body: [
      'Hey,',
      '',
      `I need help with...`,
      '',
      `The link to the secret santa: ${groupUrl}`,
      `My participant ID: ${participantId}`,
      '',
      'Thanks!',
    ].join('\n'),
  });
